export function HowItWorks() {
    return (
        <section id="how-it-works" className="section section--alt">
            <div className="container">
                <div className="section__header animate-on-scroll">
                    <span className="section__label">How It Works</span>
                    <h2 className="section__title">Three Steps to Impact</h2>
                    <p className="section__desc">
                        Funding ideas on Bitcoin has never been simpler. No intermediaries, no
                        delays, no hidden fees.
                    </p>
                </div>

                <div className="steps animate-on-scroll" style={{ transitionDelay: '200ms' }}>
                    <div className="step">
                        <div className="step__number">1</div>
                        <h3 className="step__title">Connect Wallet</h3>
                        <p className="step__desc">
                            Connect your OP_WALLET or UniSat wallet in one click. Your keys, your
                            Bitcoin.
                        </p>
                    </div>

                    <div className="step">
                        <div className="step__number">2</div>
                        <h3 className="step__title">Choose a Campaign</h3>
                        <p className="step__desc">
                            Browse active campaigns, read their stories, and pick the one that
                            resonates with you.
                        </p>
                    </div>

                    <div className="step">
                        <div className="step__number">3</div>
                        <h3 className="step__title">Fund with Bitcoin</h3>
                        <p className="step__desc">
                            Send any amount directly to the campaign. On-chain, transparent,
                            irreversible.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}
